import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Box from '../box/box.jsx';
import styles from './connection-modal.css';

const ErrorStep = props => (
    <Box className={styles.body}>
        <Box className={styles.activityArea}>
            <div className={styles.centeredRow}>
                <div className={styles.peripheralActivity}>
                    <img
                        className={styles.errorIcon}
                        src="/static/assets/c25c9919121ad3094ae6d673228866d0.svg"
                    />
                </div>
            </div>
            <div className={styles.instructions}>
                <p>Hata!</p>
                <p>{props.error || 'Bilinmeyen bir hata oluştu.'}</p>
            </div>
        </Box>
        <Box className={styles.bottomArea}>
            <div className={classNames(styles.bottomAreaItem)}>
                <button
                    className={classNames(styles.connectionButton)}
                    onClick={props.onScanning}
                >
                    Tekrar Dene
                </button>
            </div>
            <div className={classNames(styles.bottomAreaItem)}>
                <button
                    className={classNames(styles.connectionButton)}
                    onClick={props.onCancel}
                >
                    İptal
                </button>
            </div>
        </Box>
    </Box>
);

ErrorStep.propTypes = {
    error: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onHelp: PropTypes.func.isRequired,
    onScanning: PropTypes.func.isRequired
};

export default ErrorStep;
